/**
 * アプリ内ブラウザ（WebView）の検出
 *
 * LINE, Facebook, Instagram, Twitter/X などのアプリ内ブラウザでは
 * GoogleのOAuth認証がセキュリティポリシーによりブロックされるため、
 * 事前に検出してユーザーに外部ブラウザでの利用を案内する
 */

type InAppBrowserType = 'line' | 'facebook' | 'instagram' | 'twitter' | 'tiktok' | 'other-webview' | null;

interface InAppBrowserResult {
  isInAppBrowser: boolean;
  browserType: InAppBrowserType;
  displayName: string | null;
}

/**
 * アプリ内ブラウザかどうかを検出する
 */
export function detectInAppBrowser(): InAppBrowserResult {
  const ua = navigator.userAgent || '';

  // LINE
  if (/\bLine\//i.test(ua)) {
    return { isInAppBrowser: true, browserType: 'line', displayName: 'LINE' };
  }

  // Facebook (FBAN = Facebook App Name, FBAV = Facebook App Version)
  if (/\bFBAN\b/i.test(ua) || /\bFBAV\b/i.test(ua)) {
    return {
      isInAppBrowser: true,
      browserType: 'facebook',
      displayName: 'Facebook',
    };
  }

  // Instagram
  if (/\bInstagram\b/i.test(ua)) {
    return {
      isInAppBrowser: true,
      browserType: 'instagram',
      displayName: 'Instagram',
    };
  }

  // Twitter/X
  if (/\bTwitter\b/i.test(ua)) {
    return {
      isInAppBrowser: true,
      browserType: 'twitter',
      displayName: 'X (Twitter)',
    };
  }

  // TikTok
  if (/\bTikTok\b/i.test(ua) || /\bBytedance\b/i.test(ua)) {
    return {
      isInAppBrowser: true,
      browserType: 'tiktok',
      displayName: 'TikTok',
    };
  }

  // 汎用WebView検出（Android/iOS）
  // - Android: "wv" in UA indicates WebView
  // - iOS: Missing "Safari" but has "AppleWebKit" often indicates WebView
  const isAndroidWebView = /\bwv\b/.test(ua) && /\bAndroid\b/i.test(ua);
  const isIOSWebView = /\bAppleWebKit\b/i.test(ua) && /\biPhone|iPad|iPod\b/i.test(ua) && !/\bSafari\b/i.test(ua);

  if (isAndroidWebView || isIOSWebView) {
    return {
      isInAppBrowser: true,
      browserType: 'other-webview',
      displayName: null,
    };
  }

  return { isInAppBrowser: false, browserType: null, displayName: null };
}
